<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('despachosmaquinaria')">Compra:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.id}}
    </h1>
    <trashed-message v-if="compra.deleted_at" class="mb-6" @restore="restore">
     Customer Removed!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <text-input v-model="form.cantidad" :error="form.errors.cantidad" class="pr-6 pb-8 w-full lg:w-1/2" label="Cantidad" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!compra.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Compra</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Guardar Compra</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.id}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    compra: Object,
  
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.compra.id,
        cantidad: this.compra.cantidad,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('compras.update', this.compra.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('compras.destroy', this.compra.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('compras.restore', this.compra.id))
      }
    },
  },
}
</script>
